'use strict';

const StickyHandler = require('./sticky_handler');

const PURCHASE_CLUSTER_PADDING = 12;

const StickyPurchaseCluster = {
  init(payload, done) {
    const element = document.querySelector(
      '#purchase-cluster > .purchase-cluster-container'
    );
    const container = document.querySelector('.deal-container');
    new StickyHandler(element, container, PURCHASE_CLUSTER_PADDING);

    done();
  },
};

module.exports = StickyPurchaseCluster;
